// extracted by mini-css-extract-plugin
module.exports = {"table":"src-components-layouts-table-module__table--3IfGt"};